/**
 * สิทธิ์ดูข้อมูลหน้า dashboard ของ user ปัจจุบัน — กติกาเดียวกับ backend (getTeamScope ใน packages/api/src/auth.ts)
 *   - "all"  = admin / manager / marketing ที่มีสิทธิ์ "ดูทุกทีม"
 *   - "team" = marketing ที่มีทีม (เห็นเฉพาะทีมตัวเอง · ข้อมูลที่แยกทีมไม่ได้จะถูกซ่อน)
 *   - "none" = marketing ไม่มีทีม / user / role อื่น — ไม่เห็นข้อมูลเลย
 * ใช้ซ่อนเมนู/หน้า/พาเนลเท่านั้น — backend กันสิทธิ์ทุก endpoint อยู่แล้ว
 */
export type DataAccess = "all" | "team" | "none";

export function dataAccessOf(
  user: { role: string; group_id?: number | null; can_view_all_teams?: boolean } | null | undefined
): DataAccess {
  if (!user) return "none";
  if (user.role === "admin" || user.role === "manager") return "all";
  if (user.role !== "marketing") return "none";
  if (user.can_view_all_teams) return "all";
  return user.group_id != null ? "team" : "none";
}
